"use strict";
exports.__esModule = true;
exports.SETTINGS_CANCEL_MEMBERSHIP = void 0;
exports.SETTINGS_CANCEL_MEMBERSHIP = {
    CL_SUSPENDED: 'Your credit line will be suspended',
    BAL_TO_COLLECTORS: 'Your outstanding balance may be transferred to collections',
    INELIGIBLE_REAPPLY: 'You’ll be ineligible to re-apply for Flex service until after you’ve settled your balance',
    REAPPLY_LIMITED: 'Your options when re-applying may be limited'
};
